import React, { useImperativeHandle, forwardRef, useState, useEffect, useMemo } from "react";
import { Row, Col } from "react-bootstrap";
import defaultimg from "../../icons/noimage.png";
import {
isAlphanumericMinusPlusPercent
,isAllowDashedSpecialCharactersPlusMinusPercentAmpersand
} from "../../functions/validations";
import { PQRHeader } from "./PQRObjects/PQRHeader";
import { SingleInput } from "../utility/forms/inputs/InputsTransaction"
import { PQRPage3TableColumnN, PQRToughnessTestTable } from "../utility/common/TransactionComponents/WPQ_PQR_Test_Table_Components";
import { AddUpdatePQRHeader } from "./PQRObjects/PQR_Validations";
import { validatePQRFormPage2, validatePQRTestArrayEnhanced } from "./PQRObjects/PQR_ValidationConfig";
import {
  PQR_GroovePage2,
  PQR_OverlayPage2,
} from "./PQRObjects/PQR_entity";
import { Action, Status, MessageTypes } from "../utility/common/constants/CommonConstants";
import { getAllUserMaster, IsUserMasterBand } from "../../Services/user-service";
import { DotLoader } from "react-spinners";
import { UnifiedSignatureSection } from "../utility/common/TransactionComponents/UnifiedSignatureSection";
import { fetchImagePreview } from "../utility/common/TransactionComponents/CommonImages";
import { handlePQRGeneralSubmit, handlePQRGeneralSubmitTemp, createPQRTestDataObjects } from "../utility/common/TransactionComponents/TransactionSubmitUtils";

const PQRPage2 = forwardRef(
  (
    {
      headerObj,
      setheaderObj,
      detailObj,
      copydata,
      WPStype,
      setaction,
      action,
      isDisabled
    },
    ref
  ) => {

    const avatar = { defaultimg };
    const [users, setUsers] = useState(null);
    let folderwld = "wld_signatures";
    let sessionName = "PQRGrooveOverlay";
    const [isReadonly] = useState(false);
    const [isEdited, setIsEdited] = useState(false);
    const [loading, setLoading] = useState(false);
    const [previewuser, setPreviewuser] = useState(avatar.defaultimg);
    const [previewapproved, setPreviewapproved] = useState(avatar.defaultimg);

    let Tensile_Test = headerObj?.Tensile_Test;
    let GuidedBend_Test = headerObj?.GuidedBend_Test;
    let Toughness_Test = headerObj?.Toughness_Test;
    let Other_Test = headerObj?.Other_Test;
    let Certification = headerObj?.Certification;
    let CertificationLabRef = headerObj?.CertificationLabRef;
    let GuidedBend_Test_Overlay = headerObj?.GuidedBend_Test_Overlay;

    const [Tensile_Test_Disabled, setTensile_Test_Disabled] = useState(false)

    const [GuidedBend_Test_Overlay_Disabled, setGuidedBend_Test_Overlay_Disabled] = useState(false)
    const [GuidedBend_Test_Disabled, setGuidedBend_Test_Disabled] = useState(false)
    const [Toughness_Test_Disabled, setToughness_Test_Disabled] = useState(false)
    const [Other_Test_Disabled, setOther_Test_Disabled] = useState(false)
    const [Certification_Disabled, setCertification_Disabled] = useState(false)

    // Show flags for PDF generation (when checked = show in PDF)
    const [showTensileTest, setShowTensileTest] = useState(headerObj?.showTensileTest || false) // Default to false
    const [showGuidedBendTest, setShowGuidedBendTest] = useState(headerObj?.showGuidedBendTest || false) // Default to false
    const [showOtherTest, setShowOtherTest] = useState(headerObj?.showOtherTest || false) // Default to false

    // Update show flags when headerObj changes (for edit mode)
    useEffect(() => {
      if (headerObj) {
        setShowTensileTest(headerObj.showTensileTest || false);
        setShowGuidedBendTest(headerObj.showGuidedBendTest || false);
        setShowOtherTest(headerObj.showOtherTest || false);
      }
    }, [headerObj?.showTensileTest, headerObj?.showGuidedBendTest, headerObj?.showOtherTest]);



    let isoverlay = WPStype === "Groove" ? false : true;



    const [fieldToughness, setFieldToughness] = useState(true);

    const [error, setError] = useState({
      PQR_Tensile_SpecimenNo: {},
      PQR_Tensile_Width: {},
      PQR_Tensile_Thickness: {},
      PQR_Tensile_Area: {},
      PQR_Tensile_UltimateLoad: {},
      PQR_Tensile_UltimateStress: {},
      PQR_Tensile_FailureLocation: {},
      PQR_Tensile_RemarksHorizontal: {},
      PQR_Tensile_ReportNumHorizontal: {},

      PQR_GB_TypeofTest: {},
      PQR_GB_Thickness: {},
      PQR_GB_Width: {},
      PQR_GB_FormerMandrilDia: {},
      PQR_GB_AngleOfBend: {},
      PQR_GB_Acceptance_Criteria: {},
      PQR_GB_Results: {},
      PQR_GB_RemarksHorizontal: {},
      PQR_GB_ReportNumHorizontal: {},

      PQR_GBV_SpecimenNo: {},
      PQR_GBV_Thickness: {},
      PQR_GBV_BM_WeldOverlay: {},
      PQR_GBV_FormerDiam: {},
      PQR_GBV_BendAngle: {},
      PQR_GBV_Acceptance_Criteria: {},
      PQR_GBV_Remarks: {},

      PQR_TT_SpecimenNo: {},
      PQR_TT_WeldingProcess: {},
      PQR_TT_NotchLocation: {},
      // PQR_TT_NotchType: {}, // Removed
      // PQR_TT_SpecimenSize: {}, // Moved to header level
      PQR_TT_TestTemp: {},
      PQR_TT_ImpactValues: {},
      PQR_TT_Avg: {},
      PQR_TT_LateralExpansion: {},
      PQR_TT_Shear: {},
      PQR_TT_RemarksHorizontal: {},
      PQR_TT_ReportNumHorizontal: {},



      PQR_OT_TypeofTest: {},
      PQR_OT_Acceptance_Criteria: {},
      PQR_OT_Results: {},
      PQR_OT_Remarks: {},
      PQR_OT_RemarksHorizontal: {},
      PQR_OT_ReportNumHorizontal: {},

      PQR_Certification_Welder_Name: {},
      PQR_Certification_ID: {},
      PQR_Certification_Process: {},

      PQR_Certification_ConductedBy: {},
      PQR_Certification_Mechanical_TestsBy: {},
      PQR_Certification_Lab_RefNo: {},

      WPSH_PreparedBy_Name: {},
      WPSH_PreparedBy_Date: {},
      WPSH_PreparedBy_Remark: {},

      WPSH_ApprovedBy_Name: {},
      WPSH_ApprovedBy_Date: {},
      WPSH_Approval_Status: {},
      WPSH_ApprovedBy_Remark: {},

      WPSH_WeldingEnggBy_Date: {},
      WPSH_WeldingEnggBy_Name: {},
      WPSH_WeldingEnggBy: {},
      WPSH_WitnessBy_Date: {},
      WPSH_WitnessBy_Name: {},
      WPSH_WitnessBy: {},
    });



    const fetchUserMaster = async () => {
      const result = await getAllUserMaster();
      const active = result.filter((item) => item.um_status === "Active")
      setUsers(active);

    };

    useEffect(() => {
      fetchUserMaster();
    }, []);



    // Optimized validation with useMemo
    const validateTestArray = (testArray, fields, maxRows) => {
      if (!testArray) return false;

      return testArray.slice(0, maxRows).some(item =>
        fields.some(field => item[field] === "")
      );

    };

    // Only recalculate when specific test arrays change
    const disabledStates = useMemo(() => {
      const validations = [
        { array: headerObj.Tensile_Test, fields: ["PQR_Tensile_SpecimenNo", "PQR_Tensile_Thickness", "PQR_Tensile_Width", "PQR_Tensile_Area", "PQR_Tensile_UltimateLoad", "PQR_Tensile_UltimateStress", "PQR_Tensile_FailureLocation"], maxRows: 4 },
        { array: headerObj.GuidedBend_Test_Overlay, fields: ["PQR_GBV_SpecimenNo", "PQR_GBV_Thickness", "PQR_GBV_BM_WeldOverlay", "PQR_GBV_FormerDiam", "PQR_GBV_BendAngle", "PQR_GBV_Acceptance_Criteria", "PQR_GBV_Remarks"], maxRows: 1 },
        { array: headerObj.GuidedBend_Test, fields: ["PQR_GB_TypeofTest", "PQR_GB_Thickness", "PQR_GB_Width", "PQR_GB_FormerMandrilDia", "PQR_GB_AngleOfBend", "PQR_GB_Acceptance_Criteria", "PQR_GB_Results"], maxRows: 1 },
        { array: headerObj.Toughness_Test, fields: ["PQR_TT_SpecimenNo", "PQR_TT_WeldingProcess", "PQR_TT_NotchLocation", "PQR_TT_TestTemp", "PQR_TT_ImpactValues", "PQR_TT_Avg", "PQR_TT_LateralExpansion", "PQR_TT_Shear"], maxRows: 2 },
        { array: headerObj.Other_Test, fields: ["PQR_OT_TypeofTest", "PQR_OT_Acceptance_Criteria", "PQR_OT_Remarks", "PQR_OT_Results"], maxRows: 4 },
        { array: headerObj.Certification, fields: ["PQR_Certification_Welder_Name", "PQR_Certification_ID", "PQR_Certification_Process"], maxRows: 1 }
      ];

      return validations.map(({ array, fields, maxRows }) =>
        validateTestArray(array, fields, maxRows)
      );
    }, [
      headerObj.Tensile_Test,
      headerObj.GuidedBend_Test_Overlay,
      headerObj.GuidedBend_Test,
      headerObj.Toughness_Test,
      headerObj.Other_Test,
      headerObj.Certification
    ]);

    // Update state only when disabled states change
    useEffect(() => {
      const [tensile, guidedOverlay, guided, toughness, other, certification] = disabledStates;

      setTensile_Test_Disabled(tensile);
      setGuidedBend_Test_Overlay_Disabled(guidedOverlay);
      setGuidedBend_Test_Disabled(guided);
      setToughness_Test_Disabled(toughness);
      setOther_Test_Disabled(other);
      setCertification_Disabled(certification);
    }, [disabledStates])



    const validate = async (detaildata) => {
      console.log("=== VALIDATION START ===");
      console.log("WPStype:", WPStype);
      console.log("detaildata:", detaildata);
      console.log("headerObj:", headerObj);
      
      // Use unified validation for Page 2
      console.log("Starting unified validation for Page 2...");
      const validationResult = validatePQRFormPage2({
        headerObj,
        detailObj: detaildata,
        currentErrors: error,
        requiredFields: WPStype === "Groove" ? PQR_GroovePage2 : PQR_OverlayPage2,
        WPStype,
        setError,
      });
      
      console.log("Unified validation result:", validationResult);
      let isError = validationResult.isError;
      console.log("Initial isError status:", isError);

      // Enhanced test array validations
      console.log("\n=== TEST ARRAY VALIDATIONS ===");
      
      // Certification validation (always required)
      console.log("Validating Certification data:", Certification);
      const certificationResult = validatePQRTestArrayEnhanced(
        Certification, 
        ["PQR_Certification_Welder_Name", "PQR_Certification_ID", "PQR_Certification_Process"], 
        1
      );
      console.log("Certification validation result:", certificationResult);
      
      console.log("Validating CertificationLabRef data:", CertificationLabRef);
      const certificationLabResult = validatePQRTestArrayEnhanced(
        CertificationLabRef, 
        ["PQR_Certification_Lab_RefNo"], 
        1
      );
      console.log("CertificationLabRef validation result:", certificationLabResult);

      const testValidations = [
        certificationResult,
        certificationLabResult,
      ];

      if (WPStype === "Groove") {
        console.log("\n--- GROOVE WELD VALIDATIONS ---");
        
        // Tensile Test - minimum 2 rows
        console.log("Validating Tensile_Test data:", Tensile_Test);
        const tensileResult = validatePQRTestArrayEnhanced(
          Tensile_Test, 
          ["PQR_Tensile_SpecimenNo", "PQR_Tensile_Thickness", "PQR_Tensile_Width", "PQR_Tensile_Area", "PQR_Tensile_UltimateLoad", "PQR_Tensile_UltimateStress", "PQR_Tensile_FailureLocation"], 
          2
        );
        console.log("Tensile Test validation result:", tensileResult);
        testValidations.push(tensileResult);
        
        // Guided Bend Test - minimum 1 row
        console.log("Validating GuidedBend_Test data:", GuidedBend_Test);
        const guidedBendResult = validatePQRTestArrayEnhanced(
          GuidedBend_Test, 
          ["PQR_GB_TypeofTest", "PQR_GB_Thickness", "PQR_GB_Width", "PQR_GB_FormerMandrilDia", "PQR_GB_AngleOfBend", "PQR_GB_Acceptance_Criteria", "PQR_GB_Results"], 
          1
        );
        console.log("Guided Bend Test validation result:", guidedBendResult);
        testValidations.push(guidedBendResult);

        // Toughness Test - conditional validation
        console.log("fieldToughness:", fieldToughness);
        console.log("Toughness_Test data:", Toughness_Test);
        console.log("Toughness_Test[0]:", Toughness_Test[0]);
        
        const toughnessMinRows = (!fieldToughness || (Toughness_Test[0] && Toughness_Test[0].PQR_TT_SpecimenNo === "Not Applicable")) ? 0 : 2;
        console.log("Calculated toughnessMinRows:", toughnessMinRows);
        
        if (toughnessMinRows > 0) {
          console.log("Validating Toughness Test (required)...");
          const toughnessResult = validatePQRTestArrayEnhanced(
            Toughness_Test, 
            ["PQR_TT_SpecimenNo", "PQR_TT_WeldingProcess", "PQR_TT_NotchLocation", "PQR_TT_TestTemp", "PQR_TT_ImpactValues", "PQR_TT_Avg", "PQR_TT_LateralExpansion", "PQR_TT_Shear"], 
            toughnessMinRows
          );
          console.log("Toughness Test validation result:", toughnessResult);
          testValidations.push(toughnessResult);
        } else {
          console.log("Toughness Test validation skipped (not required or marked as Not Applicable)");
        }

      }

      // Other Test validation
      console.log("\n--- OTHER TEST VALIDATION ---");
      console.log("Validating Other_Test data:", Other_Test);
      const otherTestResult = validatePQRTestArrayEnhanced(
        Other_Test, 
        ["PQR_OT_TypeofTest", "PQR_OT_Acceptance_Criteria", "PQR_OT_Results", "PQR_OT_Remarks"], 
        1
      );
      console.log("Other Test validation result:", otherTestResult);
      testValidations.push(otherTestResult);

      // Overlay-specific validation
      if (WPStype === "Overlay") {
        console.log("\n--- OVERLAY WELD VALIDATIONS ---");
        console.log("Validating GuidedBend_Test_Overlay data:", GuidedBend_Test_Overlay);
        const overlayResult = validatePQRTestArrayEnhanced(
          GuidedBend_Test_Overlay, 
          ["PQR_GBV_SpecimenNo", "PQR_GBV_Thickness", "PQR_GBV_BM_WeldOverlay", "PQR_GBV_FormerDiam", "PQR_GBV_BendAngle", "PQR_GBV_Acceptance_Criteria", "PQR_GBV_Remarks"], 
          1
        );
        console.log("Overlay validation result:", overlayResult);
        testValidations.push(overlayResult);
      }

      // Check all test validations
      console.log("\n=== FINAL VALIDATION CHECK ===");
      console.log("All test validations:", testValidations);
      
      testValidations.forEach((result, index) => {
        console.log(`Validation ${index + 1}:`, result);
        if (result.isError) {
          console.log(`Validation ${index + 1} has errors:`, result.errors);
          isError = true;
        }
      });

      console.log("Final isError status:", isError);
      console.log("=== VALIDATION END ===\n");

      return isError;
    };

    // Common function to handle test toggle logic
    const handleTestToggle = (isChecked, arrayName, fields, notApplicableValue = "Not Applicable") => {
      setheaderObj((prevState) => ({
        ...prevState,
        [arrayName]: prevState[arrayName].map((test, i) => {
          if (!isChecked && i === 0) {
            // Set first row to "Not Applicable"
            const updates = Object.fromEntries(fields.map(field => [field, notApplicableValue]));
            return { ...test, ...updates, errormessage: "", error: false };
          } else {
            // Set all rows to empty
            const updates = Object.fromEntries(fields.map(field => [field, ""]));
            return { ...test, ...updates, errormessage: "", error: false };
          }
        })
      }));
    };

    const handleCheckboxChange = (e) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const isChecked = e.target.checked;

      setheaderObj((header) => ({
        ...header,
        Impact: isChecked ? "Yes" : "No",
      }));

      setFieldToughness(isChecked);

      const toughnessFields = ["PQR_TT_SpecimenNo", "PQR_TT_WeldingProcess", "PQR_TT_NotchLocation", "PQR_TT_TestTemp", "PQR_TT_ImpactValues", "PQR_TT_Avg", "PQR_TT_LateralExpansion", "PQR_TT_Shear"];
      handleTestToggle(isChecked, "Toughness_Test", toughnessFields);
    };



    const handleAdd = async (approvalstatus) => {
      let result = true;
      headerObj.PQR_SignatureApproved = headerObj.PQR_SignatureApproved || "";
      headerObj.WPSH_ApprovedBy_Name = headerObj.WPSH_ApprovedBy_Name || "";
      headerObj.WPSH_ApprovedBy = headerObj.WPSH_ApprovedBy_Name || "";
      headerObj.WPSH_PreparedBy_Name = headerObj.WPSH_PreparedBy_Name || "";
      headerObj.PQR_SignaturePrepared = headerObj.PQR_SignaturePrepared || "";

      // Add show flags to headerObj before creating test data objects
      // headerObj.showTensileTest = showTensileTest;
      // headerObj.showGuidedBendTest = showGuidedBendTest;
      // headerObj.showOtherTest = showOtherTest;

      // Use common function to create test data objects
      const testObjects = createPQRTestDataObjects(headerObj);
      const { TT, GB1, GB2, TOUGH, HARD, OTHER, CERTI, Lab_refno, OTHERData, PAGE2_NOTES, REMAIN } = testObjects;

      // Set session storage values for REMAIN object
      REMAIN.WPSH_ApprovedBy = sessionStorage.getItem("User");
      REMAIN.WPSH_PreparedBy = sessionStorage.getItem("User");
      
    //  Explicitly add show flags to REMAIN object
      REMAIN.showTensileTest = showTensileTest;
      REMAIN.showGuidedBendTest = showGuidedBendTest;
      REMAIN.showOtherTest = showOtherTest;
      
      // Also add show flags to OTHERData object (contains remarks and report numbers)
      // if (OTHERData) {
      //   OTHERData.showTensileTest = showTensileTest;
      //   OTHERData.showGuidedBendTest = showGuidedBendTest;
      //   OTHERData.showOtherTest = showOtherTest;
      // }
       let StatusPQR = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        WPSH_Status: approvalstatus,
        WPSH_Approval_Status: headerObj.WPSH_Approval_Status
      };

      const postList = [
        TT,
        GB1,
        GB2,
        TOUGH,
        HARD,
        OTHER,
        CERTI,
        Lab_refno,
        OTHERData,
        PAGE2_NOTES,
        REMAIN,
        StatusPQR
      ];



      await AddUpdatePQRHeader(undefined, postList)
        .catch((e) => {
          result = false;
        })
        .then(async (r) => {

          if (r == MessageTypes.SpecialCharacters)
            result = MessageTypes.SpecialCharacters


        });
      return Promise.resolve(result);
    };


    const checkIfUsernameExists = async () => {
      let res = await IsUserMasterBand();
      if (res !== undefined) return res.data.message;
      else return false;
    };


    const validateTemp = async () => {
      let isError = false;
      return { isError };
    };

    const handleSubmitTemp = () => handlePQRGeneralSubmitTemp(isEdited, validateTemp, handleAdd, setLoading, setIsEdited, headerObj?.WPSH_Status);

    const handleSubmit = async () => {
      const isUsernamePresent = await checkIfUsernameExists();
      const status = !isUsernamePresent ? Status.StatusTempSaved : Status.StatusFreezed;

      const result = await handlePQRGeneralSubmit(validate, handleAdd, setLoading, status);

      if (result === MessageTypes.Required) {
        return MessageTypes.RequiredAll;
      }

      return result;
    };

    useImperativeHandle(ref, () => ({
      funcOnNext2: async () => {
        let res = false;
        res = await handleSubmit();
        return res;
      },

      funcOnNextTemp2: async () => {
        let res = false;
        res = await handleSubmitTemp();
        return res;
      },
    }));


    // Common function to check if max rows are filled and update disabled state
    const checkAndUpdateDisabledState = (arrayName, fieldNames, maxRows, setDisabledFunc) => {
      const array = headerObj[arrayName];
      if (!array || maxRows <= 0) return;

      let filledRows = 0;
      for (let i = 0; i < Math.min(maxRows, array.length); i++) {
        const row = array[i];
        const isRowFilled = fieldNames.every(field => row[field] && row[field].trim() !== '');
        if (isRowFilled) filledRows++;
      }

      setDisabledFunc(filledRows < maxRows);
    };

    const handleChange = (e) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const { name, value } = e.target;

      setheaderObj((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };

    const handleChangeTensileTestarray = (Index, key, newValue) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const updatedheadertestObj = { ...headerObj };
      updatedheadertestObj.Tensile_Test[Index][key] = newValue;
      setheaderObj(updatedheadertestObj);

      setTimeout(() => {
        checkAndUpdateDisabledState('Tensile_Test', ["PQR_Tensile_SpecimenNo", "PQR_Tensile_Thickness", "PQR_Tensile_Width", "PQR_Tensile_Area", "PQR_Tensile_UltimateLoad", "PQR_Tensile_UltimateStress", "PQR_Tensile_FailureLocation"], 4, setTensile_Test_Disabled);
      }, 0);
    };

    const handleChangeGuidedBandTestarray = (Index, key, newValue) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const updatedheadertestObj = { ...headerObj };
      updatedheadertestObj.GuidedBend_Test[Index][key] = newValue;
      setheaderObj(updatedheadertestObj);

      setTimeout(() => {
        checkAndUpdateDisabledState('GuidedBend_Test', ["PQR_GB_TypeofTest", "PQR_GB_Thickness", "PQR_GB_Width", "PQR_GB_FormerMandrilDia", "PQR_GB_AngleOfBend", "PQR_GB_Acceptance_Criteria", "PQR_GB_Results"], 1, setGuidedBend_Test_Disabled);
      }, 0);
    };

    const handleChangeGuidedBandTestOverlayarray = (Index, key, newValue) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const updatedheadertestObj = { ...headerObj };
      updatedheadertestObj.GuidedBend_Test_Overlay[Index][key] = newValue;
      setheaderObj(updatedheadertestObj);

      setTimeout(() => {
        checkAndUpdateDisabledState('GuidedBend_Test_Overlay', ["PQR_GBV_SpecimenNo", "PQR_GBV_Thickness", "PQR_GBV_BM_WeldOverlay", "PQR_GBV_FormerDiam", "PQR_GBV_BendAngle", "PQR_GBV_Acceptance_Criteria", "PQR_GBV_Remarks"], 1, setGuidedBend_Test_Overlay_Disabled);
      }, 0);
    };

    const handleChangeToughnessTestarray = (Index, key, newValue) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const updatedheadertestObj = { ...headerObj };
      updatedheadertestObj.Toughness_Test[Index][key] = newValue;
      setheaderObj(updatedheadertestObj);

      setTimeout(() => {
        checkAndUpdateDisabledState('Toughness_Test', ["PQR_TT_SpecimenNo", "PQR_TT_WeldingProcess", "PQR_TT_NotchLocation", "PQR_TT_TestTemp", "PQR_TT_ImpactValues", "PQR_TT_Avg", "PQR_TT_LateralExpansion", "PQR_TT_Shear"], 2, setToughness_Test_Disabled);
      }, 0);
    };



    const handleChangeOther_Testarray = (Index, key, newValue) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const updatedheadertestObj = { ...headerObj };
      updatedheadertestObj.Other_Test[Index][key] = newValue;
      setheaderObj(updatedheadertestObj);

      setTimeout(() => {
        checkAndUpdateDisabledState('Other_Test', ["PQR_OT_TypeofTest", "PQR_OT_Acceptance_Criteria", "PQR_OT_Results", "PQR_OT_Remarks"], 4, setOther_Test_Disabled);
      }, 0);
    };

    const handleCertificationarray = (Index, key, newValue) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const updatedheadertestObj = { ...headerObj };
      updatedheadertestObj.Certification[Index][key] = newValue;
      setheaderObj(updatedheadertestObj);

      setTimeout(() => {
        checkAndUpdateDisabledState('Certification', ["PQR_Certification_Welder_Name", "PQR_Certification_ID", "PQR_Certification_Process"], 1, setCertification_Disabled);
      }, 0);
    };

    const handleCertificationLabRef = (Index, key, newValue) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const updatedheadertestObj = { ...headerObj };
      updatedheadertestObj.CertificationLabRef[Index][key] = newValue;
      setheaderObj(updatedheadertestObj);
    };



    const handleChangeHeader = (e) => {
      handleChange(e);
    };


    const fetchbyuserprofile = async (userprofile) => {
      await fetchImagePreview(
        folderwld,
        userprofile,
        setPreviewuser,
        avatar.defaultimg
      );
    };

    const fetchapproveUserProfile = async (userprofile) => {
      await fetchImagePreview(
        folderwld,
        userprofile,
        setPreviewapproved,
        avatar.defaultimg
      );
    };



    useEffect(() => {
      if ((action === Action.ActionEdit || action === Action.ActionCopy) && headerObj?.PQR_SignaturePrepared) {
        fetchbyuserprofile(headerObj.PQR_SignaturePrepared);
      }
    }, [headerObj?.PQR_SignaturePrepared, action]);

    useEffect(() => {
      if ((action === Action.ActionEdit || action === Action.ActionCopy) && headerObj?.PQR_SignatureApproved) {
        fetchapproveUserProfile(headerObj.PQR_SignatureApproved);
      }
    }, [headerObj?.PQR_SignatureApproved, action]);

    return (
      <Row className="font">
        {loading && (
          <div className="loader-overlay">
            <DotLoader size={80} className="pageloader" />
          </div>
        )}
        <PQRHeader headerObj={headerObj}></PQRHeader>
        {!isoverlay ? (
          <Row style={{ padding: "20px 60px", opacity: isDisabled ? 0.5 : 1, pointerEvents: isDisabled ? 'none' : 'auto' }}>
            <Row className="mb-1">
              <Col md={12}>
                <div className="checkboxproject">
                  <input
                    type="checkbox"
                    placeholder=" "
                    className="form-check-input"
                    id="chkcode"
                    onChange={(e) => {
                    const checked = e.target.checked;
                    setShowTensileTest(checked);
                    setheaderObj(prev => ({ ...prev, showTensileTest: checked }));
                    if (action === Action.ActionEdit) setIsEdited(true);
                  }}
                    checked={showTensileTest}
                  />{" "}
                  <span className="WPS-blue-text" style={{ position: "relative", bottom: "-2px", left: "5px" }}>Tensile Test (QW-150)</span>
                </div>
                <br />
                <PQRPage3TableColumnN
                  columns={7}
                  sessionName={sessionName}
                  maxLength={[20, 6, 6, 7, 7, 7, 22]}
                  width={[140, 140, 140, 140]}
                  variant="test"
                  array={Tensile_Test}
                  setheaderObj={setheaderObj}
                  disabled={Tensile_Test_Disabled}
                  numberofrowsdisabled={4}
                  setError={setError}
                  title={["Specimen No.", "Thickness(mm)", "Width (mm)", "Area (mm²)", "Ultimate Total Load (kN)", "U.T.S. (MPa)", "Type of Failure and Location"]}
                  name={["PQR_Tensile_SpecimenNo", "PQR_Tensile_Thickness", "PQR_Tensile_Width",
                    "PQR_Tensile_Area", "PQR_Tensile_UltimateLoad", "PQR_Tensile_UltimateStress", "PQR_Tensile_FailureLocation"]}
                  status={[error.PQR_Tensile_SpecimenNo.status, error.PQR_Tensile_Thickness.status,
                  error.PQR_Tensile_Width.status, error.PQR_Tensile_Area.status,
                  error.PQR_Tensile_UltimateLoad.status, error.PQR_Tensile_UltimateStress.status,
                  error.PQR_Tensile_FailureLocation.status]}
                  message={[error.PQR_Tensile_SpecimenNo.message, error.PQR_Tensile_Thickness.message,
                  error.PQR_Tensile_Width.message, error.PQR_Tensile_Area.message,
                  error.PQR_Tensile_UltimateLoad.message, error.PQR_Tensile_UltimateStress.message,
                  error.PQR_Tensile_FailureLocation.message]}
                  allowlistfunction={isAllowDashedSpecialCharactersPlusMinusPercentAmpersand}
                  handleChangetestarray={handleChangeTensileTestarray}
                />
              </Col>

              <Col md={12}>
                <SingleInput
                  disabled={copydata}
                  name="PQR_Tensile_RemarksHorizontal"
                  type="text"
                  maxLength={90}
                  status={error.PQR_Tensile_RemarksHorizontal.status}
                  value={headerObj?.PQR_Tensile_RemarksHorizontal}
                  onChange={handleChangeHeader}
                  label="Remarks"
                  message={error.PQR_Tensile_RemarksHorizontal.message}
                  setError={setError}
                   allowlistfunction={isAllowDashedSpecialCharactersPlusMinusPercentAmpersand}
                  error={error}
                ></SingleInput>
              </Col>
              <Col md={12}>
                <SingleInput
                  disabled={copydata}
                  name="PQR_Tensile_ReportNumHorizontal"
                  type="text"
                  maxLength={90}
                  status={error.PQR_Tensile_ReportNumHorizontal.status}
                  value={headerObj?.PQR_Tensile_ReportNumHorizontal}
                  onChange={handleChangeHeader} 
                  label="Report Number"
                  message={error.PQR_Tensile_ReportNumHorizontal.message}
                  setError={setError}
                   allowlistfunction={isAllowDashedSpecialCharactersPlusMinusPercentAmpersand}
                  error={error}
                ></SingleInput>
              </Col>
            </Row>
          </Row>
        ) : (
          ""
        )}

        <Row style={{ padding: "20px 60px", opacity: isDisabled ? 0.5 : 1, pointerEvents: isDisabled ? 'none' : 'auto' }} className="PQR-Page-row-padding">
          <Row className="mb-1">
            <Col md={12}>
              <div className="checkboxproject">
                <input
                  type="checkbox"
                  placeholder=" "
                  className="form-check-input"
                  id="chkcode"
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setShowGuidedBendTest(checked);
                    setheaderObj(prev => ({ ...prev, showGuidedBendTest: checked }));
                    if (action === Action.ActionEdit) setIsEdited(true);
                  }}
                  checked={showGuidedBendTest}
                />{" "}
                <span className="WPS-blue-text" style={{ position: "relative", bottom: "-2px", left: "5px" }}>GUIDED BEND TEST (QW-160)</span>
              </div>
              <br />
              {isoverlay ? (
                // <PQR_Page2_Table
                <PQRPage3TableColumnN
                  sessionName={sessionName}
                  columns={7}
                  width={[143, 143, 143, 143]}
                  maxLength={[32, 4, 8, 8, 5, 10, 12]}
                  numberofrowsdisabled={1}
                  array={GuidedBend_Test_Overlay}
                  setheaderObj={setheaderObj}
                  disabled={GuidedBend_Test_Overlay_Disabled}
                  setError={setError}
                  allowlistfunction={isAlphanumericMinusPlusPercent}
                  title={["Nos. of specimen", "Thk (mm)", "Breadth (mm)", "Former Diameter (mm)", "Bend Angle (degree)", "Acceptance Criteria", "Remarks"]}
                  name={["PQR_GBV_SpecimenNo", "PQR_GBV_Thickness", "PQR_GBV_BM_WeldOverlay", "PQR_GBV_FormerDiam", "PQR_GBV_BendAngle", "PQR_GBV_Acceptance_Criteria", "PQR_GBV_Remarks"]}
                  status={[error.PQR_GBV_SpecimenNo.status, error.PQR_GBV_Thickness.status,
                  error.PQR_GBV_BM_WeldOverlay.status, error.PQR_GBV_FormerDiam.status,
                  error.PQR_GBV_BendAngle.status, error.PQR_GBV_Acceptance_Criteria.status,
                  error.PQR_GBV_Remarks.status
                  ]}
                  message={[error.PQR_GBV_SpecimenNo.message, error.PQR_GBV_Thickness.message,
                  error.PQR_GBV_BM_WeldOverlay.message, error.PQR_GBV_FormerDiam.message,
                  error.PQR_GBV_BendAngle.message, error.PQR_GBV_Acceptance_Criteria.message,
                  error.PQR_GBV_Remarks.message
                  ]}

                  handleChangetestarray={handleChangeGuidedBandTestOverlayarray}
                />
              ) : (
                <PQRPage3TableColumnN
                  columns={7}
                  sessionName={sessionName}
                  maxLength={[25, 3, 5, 3, 4, 8, 15]}
                  width={[120, 120, 120, 120, 120, 120, 120]}
                  array={GuidedBend_Test}
                  disabled={GuidedBend_Test_Disabled}
                  setheaderObj={setheaderObj}
                  setError={setError}
                  allowlistfunction={isAllowDashedSpecialCharactersPlusMinusPercentAmpersand}
                  title={["Identification", "Thickness (mm)", "Width (mm)", "Former Mandril Dia (mm)", "Angle of Bend (°)", "Acceptance Criteria", "Results"]}
                  name={["PQR_GB_TypeofTest", "PQR_GB_Thickness", "PQR_GB_Width", "PQR_GB_FormerMandrilDia", "PQR_GB_AngleOfBend", "PQR_GB_Acceptance_Criteria", "PQR_GB_Results"]}
                  status={[error.PQR_GB_TypeofTest.status, error.PQR_GB_Thickness.status, error.PQR_GB_Width.status, error.PQR_GB_FormerMandrilDia.status, error.PQR_GB_AngleOfBend.status, error.PQR_GB_Acceptance_Criteria.status, error.PQR_GB_Results.status]}
                  message={[error.PQR_GB_TypeofTest.message, error.PQR_GB_Thickness.message, error.PQR_GB_Width.message, error.PQR_GB_FormerMandrilDia.message, error.PQR_GB_AngleOfBend.message, error.PQR_GB_Acceptance_Criteria.message, error.PQR_GB_Results.message]}
                  handleChangetestarray={handleChangeGuidedBandTestarray}
                />
              )}
            </Col>

            <Col md={12}>
              <SingleInput
                disabled={copydata}
                name="PQR_GB_RemarksHorizontal"
                type="text"
                maxLength={90}
                status={error.PQR_GB_RemarksHorizontal.status}
                value={headerObj?.PQR_GB_RemarksHorizontal}
                onChange={handleChangeHeader}
                label="Remarks"
                message={error.PQR_GB_RemarksHorizontal.message}
                setError={setError}
                error={error}
                 allowlistfunction={isAlphanumericMinusPlusPercent}
              ></SingleInput>
            </Col>
            <Col md={12}>
              <SingleInput
                disabled={copydata}
                name="PQR_GB_ReportNumHorizontal"
                type="text"
                maxLength={90}
                status={error.PQR_GB_ReportNumHorizontal.status}
                value={headerObj?.PQR_GB_ReportNumHorizontal}
                onChange={handleChangeHeader}
                label="Report Number"
                 allowlistfunction={isAlphanumericMinusPlusPercent}
                message={error.PQR_GB_ReportNumHorizontal.message}
                setError={setError}
                
                error={error}
              ></SingleInput>
            </Col>
          </Row>
        </Row>

        {!isoverlay ? (
          <Row style={{ padding: "20px 60px" }}>
            <Row className="mb-1">
              <Col md={12}>
                <div className="checkboxproject">
                  <input
                    type="checkbox"
                    placeholder=" "
                    className="form-check-input"
                    id="chkcode"

                    onChange={handleCheckboxChange}

                    checked={(() => {
                      if (!headerObj.Toughness_Test || !headerObj.Toughness_Test[0] || !headerObj?.Toughness_Test[0]?.PQR_TT_SpecimenNo) {
                        return fieldToughness;
                      }
                      return headerObj?.Toughness_Test[0]?.PQR_TT_SpecimenNo === "Not Applicable" ? false : fieldToughness;
                    })()}

                  />{" "}
                  <span className="WPS-blue-text" style={{ position: "relative", bottom: "-2px", left: "5px" }}>Toughness Test (QW-170)</span>
                </div>
                <br />
                <PQRToughnessTestTable
                  array={Toughness_Test}
                  disabled={(() => {
                    if (!headerObj?.Toughness_Test || !headerObj?.Toughness_Test[0] || !headerObj?.Toughness_Test[0].PQR_TT_SpecimenNo) {
                      return !fieldToughness;
                    }
                    return headerObj?.Toughness_Test[0]?.PQR_TT_SpecimenNo === "Not Applicable";
                  })()}
                  handleChangetestarray={handleChangeToughnessTestarray}
                  setError={setError}
                  allowlistfunction={isAlphanumericMinusPlusPercent}
                  specimenSizeValue={headerObj?.PQR_TT_SpecimenSize_Dimension}
                  onSpecimenSizeChange={(e) => handleChangeHeader({ target: { name: "PQR_TT_SpecimenSize_Dimension", value: e.target.value } })}
                  specimenSizeDisabled={(() => {
                    if (!headerObj?.Toughness_Test || !headerObj?.Toughness_Test[0] || !headerObj?.Toughness_Test[0].PQR_TT_SpecimenNo) {
                      return !fieldToughness;
                    }
                    return headerObj?.Toughness_Test[0]?.PQR_TT_SpecimenNo === "Not Applicable";
                  })()}
                />
              </Col>
              <br />
              <Col md={12} >
                <SingleInput
                  disabled={copydata}
                  name="PQR_TT_RemarksHorizontal"
                  type="text"
                  maxLength={100}
                  status={error.PQR_TT_RemarksHorizontal.status}
                  value={headerObj?.PQR_TT_RemarksHorizontal}
                  onChange={handleChangeHeader}
                  label="Remarks"
                  message={error.PQR_TT_RemarksHorizontal.message}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAllowDashedSpecialCharactersPlusMinusPercentAmpersand}
                ></SingleInput>
              </Col>
              <Col md={12} >
                <SingleInput
                  disabled={copydata}
                  name="PQR_TT_ReportNumHorizontal"
                  type="text"
                  maxLength={100}
                  status={error.PQR_TT_ReportNumHorizontal.status}
                  value={headerObj?.PQR_TT_ReportNumHorizontal}
                  onChange={handleChangeHeader}
                  label="Report Number"
                  message={error.PQR_TT_ReportNumHorizontal.message}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAllowDashedSpecialCharactersPlusMinusPercentAmpersand}
                ></SingleInput>
              </Col>
            </Row>
          </Row>
        ) : (
          ""
        )}

        {isoverlay ?
          <Row style={{ padding: "20px 60px", position: "relative", bottom: "35px", opacity: isDisabled ? 0.5 : 1, pointerEvents: isDisabled ? 'none' : 'auto' }}>
            <Row className="mb-1">
              <Col md={12}>
                <div className="checkboxproject">
                  <input
                    type="checkbox"
                    placeholder=" "
                    className="form-check-input"
                    id="chkcode"
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setShowOtherTest(checked);
                      setheaderObj(prev => ({ ...prev, showOtherTest: checked }));
                      if (action === Action.ActionEdit) setIsEdited(true);
                    }}
                    checked={showOtherTest}
                  />{" "}
                  <span className="WPS-blue-text" style={{ position: "relative", bottom: "-2px", left: "5px" }}>Other Test</span>
                </div>
                <br />
                <PQRPage3TableColumnN
                  columns={4}
                  sessionName={sessionName}
                  maxLength={[35, 10, 10, 35]}
                  array={Other_Test}
                  width={[243, 243, 243, 243]}
                  setheaderObj={setheaderObj}
                  disabled={Other_Test_Disabled}
                  setError={setError}
                  allowlistfunction={isAllowDashedSpecialCharactersPlusMinusPercentAmpersand}
                  numberofrowsdisabled={4}
                  title={["Type of Test", "Acceptance Criteria", "Results", "Remarks"]}
                  name={["PQR_OT_TypeofTest", "PQR_OT_Acceptance_Criteria", "PQR_OT_Results", "PQR_OT_Remarks"]}
                  status={[error.PQR_OT_TypeofTest.status, error.PQR_OT_Acceptance_Criteria.status, error.PQR_OT_Results.status, error.PQR_OT_Remarks.status]}
                  message={[error.PQR_OT_TypeofTest.message, error.PQR_OT_Acceptance_Criteria.message, error.PQR_OT_Results.message, error.PQR_OT_Remarks.message]}
                  handleChangetestarray={handleChangeOther_Testarray}
                />
              </Col>
              <Col md={12}>
                <SingleInput
                  disabled={copydata}
                  name="PQR_OT_RemarksHorizontal"
                  type="text"
                  maxLength={100}
                  status={error.PQR_OT_RemarksHorizontal.status}
                  value={headerObj?.PQR_OT_RemarksHorizontal}
                  onChange={handleChangeHeader}
                  label="Remarks"
                  message={error.PQR_OT_RemarksHorizontal.message}
                  setError={setError}
                                  allowlistfunction={isAllowDashedSpecialCharactersPlusMinusPercentAmpersand}
                  error={error}
                ></SingleInput>
              </Col>
              <Col md={12}>
                <SingleInput
                  disabled={copydata}
                  name="PQR_OT_ReportNumHorizontal"
                  type="text"
                  maxLength={90}
                  status={error.PQR_OT_ReportNumHorizontal.status}
                  value={headerObj?.PQR_OT_ReportNumHorizontal}
                  onChange={handleChangeHeader}
                  label="Report Number"
                  message={error.PQR_OT_ReportNumHorizontal.message}
                  setError={setError}
                                  allowlistfunction={isAllowDashedSpecialCharactersPlusMinusPercentAmpersand}
                  error={error}
                ></SingleInput>
              </Col>
            </Row>
          </Row>
          :
          <Row style={{ padding: "20px 60px", position: "relative", bottom: "35px", opacity: isDisabled ? 0.5 : 1, pointerEvents: isDisabled ? 'none' : 'auto' }}>
            <Row className="mb-1">
              <Col md={15}>
                <div className="checkboxproject">
                  <input
                    type="checkbox"
                    placeholder=" "
                    className="form-check-input"
                    id="chkcode"
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setShowOtherTest(checked);
                      setheaderObj(prev => ({ ...prev, showOtherTest: checked }));
                      if (action === Action.ActionEdit) setIsEdited(true);
                    }}
                    checked={showOtherTest}
                  />{" "}
                  <span className="WPS-blue-text" style={{ position: "relative", bottom: "-2px", left: "5px" }}>Other Test</span>
                </div>
                <br />
                <PQRPage3TableColumnN
                  columns={4}
                  sessionName={sessionName}
                  maxLength={[35, 10, 10, 35]}
                  width={[243, 243, 243, 243]}
                  array={Other_Test}
                  setheaderObj={setheaderObj}
                  disabled={Other_Test_Disabled}
                  setError={setError}
                  allowlistfunction={isAllowDashedSpecialCharactersPlusMinusPercentAmpersand}
                  numberofrowsdisabled={4}
                  title={["Type of Test", "Acceptance Criteria", "Results", "Remarks"]}
                  name={["PQR_OT_TypeofTest", "PQR_OT_Acceptance_Criteria", "PQR_OT_Results", "PQR_OT_Remarks"]}
                  status={[error.PQR_OT_TypeofTest.status, error.PQR_OT_Acceptance_Criteria.status, error.PQR_OT_Results.status, error.PQR_OT_Remarks.status]}
                  message={[error.PQR_OT_TypeofTest.message, error.PQR_OT_Acceptance_Criteria.message, error.PQR_OT_Results.message, error.PQR_OT_Remarks.message]}
                  handleChangetestarray={handleChangeOther_Testarray}
                />
              </Col>
            </Row>
          </Row>}
        <Row style={{ padding: "20px 60px", position: "relative", bottom: "45px", height: "451px", opacity: isDisabled ? 0.5 : 1, pointerEvents: isDisabled ? 'none' : 'auto' }} className="PQR-Page-row-padding">
          <Row className="mb-1" style={{ width: "55%" }}>
            <span className="WPS-blue-text" style={{ position: "relative", top: "10px" }}>Certification</span>
            <PQRPage3TableColumnN
              columns={3}
              width={[160, 140, 130]}
              width1={160}
              width2={140}
              width3={130}
              sessionName={sessionName}
              maxLength={[25, 10, 20]}
              array={Certification}
              setheaderObj={setheaderObj}
              disabled={Certification_Disabled}
              setError={setError}
                    allowlistfunction={isAllowDashedSpecialCharactersPlusMinusPercentAmpersand}
              title={["Welder's Name", "ID", "Process"]}
              name={["PQR_Certification_Welder_Name", "PQR_Certification_ID", "PQR_Certification_Process"]}
              status={[error.PQR_Certification_Welder_Name.status, error.PQR_Certification_ID.status, error.PQR_Certification_Process.status]}
              message={[error.PQR_Certification_Welder_Name.message, error.PQR_Certification_ID.message, error.PQR_Certification_Process.message]}
              handleChangetestarray={handleCertificationarray}
            />
            <span style={{ position: "relative", left: "102%", bottom: "46.6%", gap: "5px" }}>
              <Col md={3}>
                <SingleInput
                  disabled={copydata}
                  style={{ width: "500px" }}
                  name="PQR_Certification_ConductedBy"
                  type="text"
                  maxLength={55}
                  status={error.PQR_Certification_ConductedBy.status}
                  value={headerObj?.PQR_Certification_ConductedBy}
                  onChange={handleChange}
                  label="Tests Conducted by"
                  message={error.PQR_Certification_ConductedBy.message}
                  setError={setError}
                   allowlistfunction={isAllowDashedSpecialCharactersPlusMinusPercentAmpersand}
                  error={error}
                ></SingleInput>
              </Col>
            {/* <Col md={3} style={{ position: "relative", bottom: "7px", height:"50px" }}>
                <SingleInput
                  disabled={copydata}
                  name="PQR_Certification_Mechanical_TestsBy"
                  style={{ width: "500px" }}
                  type="text"
                  maxLength={30}
                  status={error.PQR_Certification_Mechanical_TestsBy.status}
                  value={headerObj?.PQR_Certification_Mechanical_TestsBy}
                  onChange={handleChange}
                  label="Mechanical Tests by"
                  message={error.PQR_Certification_Mechanical_TestsBy.message}
                  setError={setError}
                  error={error}
                ></SingleInput>
              </Col> */}
              <Col md={3} style={{ width: "80%", position: "relative", bottom: "11px"}}>
                <PQRPage3TableColumnN
                  columns={1}
                  width1={480}
                  width={[480]}
                  sessionName={sessionName}
                  maxLength={[45]}
                  array={CertificationLabRef}
                  setheaderObj={setheaderObj}
                  setError={setError}
                  title={["Laboratory Ref.Number"]}
                  allowlistfunction={isAlphanumericMinusPlusPercent}
                  name={["PQR_Certification_Lab_RefNo"]}
                  status={[error.PQR_Certification_Lab_RefNo.status]}
                  message={[error.PQR_Certification_Lab_RefNo.message]}
                  handleChangetestarray={handleCertificationLabRef}
                />
              </Col>
            </span>
          </Row>

        </Row>


        {/* -------------------------signature sections --------------------------------*/}
        <UnifiedSignatureSection
          sessionType="PQR"
          sectionType="combined"
          headerObj={headerObj}
          setheaderObj={setheaderObj}
          users={users}
          error={error}
          setError={setError}
          previewImage={previewuser}
          previewApprovedImage={previewapproved}
          fetchUserProfile={fetchbyuserprofile}
          fetchApprovedUserProfile={fetchapproveUserProfile}
          isReadonly={isReadonly}
          action={action}
          setIsEdited={setIsEdited}
          isDisabled={isDisabled}
        />
      </Row>


    );
  }
);

export default React.memo(PQRPage2);
